module.exports = __webpack_public_path__ + "static/img/notify-2.586df6e7.png";